import React, { useState } from 'react'
import { BankNoteFlyIcon, ArrowHeadDownIcon } from '../../../assets/AppIcons'
import { useTheme } from '../../../utils/ThemeColorContext'
import { useNavigate, useLocation } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getProfile, getReasonsList } from '../../../redux/Actions/getMethods'
import { setupApplication } from '../../../redux/Actions/postMethods'

import PageHeader from '../../../components/PageHeader'
import SpinnerLarge from '../../../components/SpinnerLarge'
import SubPageHeader from '../../../components/SubPageHeader'
import PrimaryButton from '../../../components/buttons/PrimaryButton'
import DefaultPage from '../DefaultPage'
import Spinner from '../../../components/Spinner'
import JourneyRoute from '../../../navigation/JourneyRoute'
import OnEnter from '../../../components/navigation/onEnter'
import { AppStyles } from '../../../assets/styles/AppStyles'
import TagManager from 'react-gtm-module'
import { useLDClient } from 'launchdarkly-react-client-sdk'

function Reasons() {
  const dispatch = useDispatch()
  const { loading } = useSelector((state) => state.authReducer)
  const { getApplication, profile } = useSelector((state) => state.dataReducer)
  const { color, isSmallScreen } = useTheme()
  const navigate = useNavigate()
  const [selectedOption, setSelectedOption] = useState('')
  const [dropdownOptions, setDropdownOptions] = useState([])
  const [isFocused, setIsFocused] = useState(false)
  const ldClient = useLDClient()

  const location = useLocation()

  useEffect(() => {
    const getReasons = async () => {
      getReasonsList()
      const reasonsList = await dispatch(getReasonsList())
      setDropdownOptions(reasonsList?.reasons)
    }
    getReasons()
  }, [])

  useEffect(() => {
    // localStorage.setItem('journeyStep', '/reason')
    if (getApplication[0]?.reason) {
      setSelectedOption(getApplication[0]?.reason)
    }
  }, [getApplication[0]?.reason])

  const handleSetupApplication = async () => {
    localStorage.setItem('reason', selectedOption)
    const getPro = await dispatch(getProfile())
    if (getPro) {
      const payload = {
        reason: selectedOption,
        // we need requested_amount to be cleared in case user navigated
        // backwards & chooses a reason that doesn't require an upfront amount
        requested_amount: null,  
      }
      const la = await dispatch(setupApplication(payload))
      const shouldShowUpfrontAmount = la?.is_general_purpose_loan || (
        ldClient?.variation('web-ask-loan-amount-upfront-for-pay-off-loans', false) &&
        la?.is_pay_off_loan
      )
      if (shouldShowUpfrontAmount) {
        navigate('/upfront-amount')
      } else {
        navigate('/employment')
      }
    }
  }

  // ==================== Checking user status  =======================//
  /* useEffect(() => {
    const temp = async () => {
      dispatch({ type: ActionTypes.LOADING_SUCCESS_WHOLE_SCREEN })
      const res = await dispatch(getProfile())
      const profile = res?.data
      const yearsResident = profile?.address?.years_resident ? profile?.address?.years_resident : 0 
      const pastYearsResident = profile?.past_address?.years_resident ? profile?.past_address?.years_resident : 0
      if (res?.status !== 200 || !profile?.address?.id || (yearsResident < 3 && pastYearsResident < 1)) {
        navigate('/address-details')
      }
      dispatch({ type: ActionTypes.LOADING_FAIL_WHOLE_SCREEN })
    }
    temp()
  }, []) */

  return (
    <DefaultPage>
      <JourneyRoute />
      {loading ? (
        <SpinnerLarge />
      ) : (
        <div className="relative container mx-auto md:w-[564px] md:space-y-10  ">
          <PageHeader
            title={'Reason for loan'}
            backButtonTitle={!['POLICY_OK', 'INPROGRESS', 'PENDING'].includes(getApplication[0]?.status) && 'Your address'}
            prevRoute={'/address-details'}
            customDescription={
              <p
                style={
                  isSmallScreen
                    ? {
                        ...AppStyles.Body,
                        color: color.Grey,
                      }
                    : {
                        ...AppStyles.Subheading1,
                        color: color.Grey,
                      }
                }
              >
                <span style={{ color: color.BlurpleTeal }}>
                  {' '}
                  {profile?.first_name}
                </span>
                , please tell us what you’ll be using your loan for.
              </p>
            }
          />
          <div
            style={{ backgroundColor: color.White }}
            className="rounded-3xl p-6 space-y-6"
          >
            <SubPageHeader Icon={BankNoteFlyIcon} text={'Loan reason'} />
            <div className="w-full flex flex-col space-y-6 md:space-y-0 md:flex-row md:space-x-6">
              <div className=" rounded-xl w-full">
                <div className="flex flex-col justify-end space-y-6 w-full">
                  <div className="relative w-full text-14">
                    <div className="relative">
                      {(isFocused || selectedOption) && (
                        <p
                          style={{
                            position: 'absolute',
                            zIndex: 1,
                            top: 0,
                            left: 0,
                            paddingLeft: 13,
                            marginTop: 12,
                            pointerEvents: 'none',
                            ...AppStyles.Caption3,
                            color: color.Grey,
                          }}
                        >
                          What do you need the loan for?
                        </p>
                      )}
                      <select
                        value={selectedOption || ''}
                        onChange={(e) => {
                          setSelectedOption(e.target.value)
                        }}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                          height: '64px',
                          width: '100%',
                          borderRadius: '16px',
                          backgroundColor: color.LightGrey,
                          color: selectedOption ? color.BlurpleTeal : color.Grey,
                          border: `1px solid ${isFocused ? color.BlurpleTeal : color.Tint3}`,
                          boxShadow: isFocused
                            ? `0 0 0 0px ${color.BlurpleTeal}`
                            : `0 0 0 1px ${color.Tint3}`,
                          fontFamily: 'MaisonMedium, sans-serif',
                          fontSize: isSmallScreen ? '16px' : '14px',
                          fontWeight: selectedOption ? '700' : '400',
                          paddingLeft: '13px',
                          paddingTop: (isFocused || selectedOption) ? '25px' : '10px',
                          paddingBottom: '10px',
                          paddingRight: '48px',
                          appearance: 'none',
                          WebkitAppearance: 'none',
                          MozAppearance: 'none',
                          cursor: 'pointer',
                          outline: 'none',
                        }}
                      >
                        <option value="" disabled hidden>
                          What do you need the loan for?
                        </option>
                        {dropdownOptions?.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                      <div
                        style={{
                          position: 'absolute',
                          right: 0,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          pointerEvents: 'none',
                        }}
                      >
                        <ArrowHeadDownIcon fill={color.BlurpleTeal} className="w-4 mx-4" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <OnEnter
            actionFunction={() => {
              if (!selectedOption) {
                return
              }
              window.heap &&
                window.heap.track('uc_why_credit', {
                  action_name: 'tap',
                  action_details: 'ucWhyCredit',
                })
              const tagManagerArgs = {
                dataLayer: {
                  event: 'onenter-pay-off',
                  page: location?.pathname,
                }
              }
              TagManager.dataLayer(tagManagerArgs)
              handleSetupApplication()
            }}
          />

          <div
            style={{
              marginTop: isSmallScreen && '24px',
              background: !isSmallScreen && 'linear-gradient(0deg, #F5F7FC 0%, rgba(245, 247, 252, 0) 100%)',
            }}
            className={
              isSmallScreen ? (
                `mt-10 md:max-w-[588px] m-[auto] fixed w-full bottom-0 px-6 pb-6 md:p-0 flex flex-col-reverse gap-5 md:gap-10 md:flex-row bg-[#F5F7FC]`
              ) : (
                `px-6 pb-6 md:p-0 fixed bottom-0 md:relative  w-full `
              )
            }
          >
            {isSmallScreen && (
              <>
                <div
                  className="absolute inset-x-0 top-[-32px] h-[24px] bg-gradient-to-t from-[#F5F7FC] to-[#F5F7FC00] pointer-events-none"
                ></div>
                <div
                  className="absolute inset-x-0 top-[-8px] h-[8px] bg-[#F5F7FC] pointer-events-none"
                />
              </>
            )}
            <PrimaryButton
              id={'pay-off'}
              text={loading ? <Spinner /> : 'Continue'}
              disabled={!selectedOption}
              onClick={() => {
                if (loading) {
                  return
                }
                window.heap &&
                  window.heap.track('uc_why_credit', {
                    action_name: 'tap',
                    action_details: 'ucWhyCredit',
                  })
                handleSetupApplication()
              }}
              className={' md:w-[260px]'}
            />
          </div>
        </div>
      )}
    </DefaultPage>
  )
}

export default Reasons
